import { useState } from 'react';

import { useDefaultPromptConfig } from '../Playground/PlaygroundHome/hooks/useDefaultPromptConfig';
import {
  useDeep,
  usePlaygroundStore,
} from '../Playground/PlaygroundHome/hooks/usePlaygroundStore';
import { ChevronToggle } from '../Playground/components/ChevronToggle';
import { PromptSettingsDisplay } from '../Playground/components/PromptSettings';

export const EvaluatorPlaygroundPromptTopBar = ({
  isAllCollapsed,
  setIsAllCollapsed,
}: {
  isAllCollapsed: boolean;
  setIsAllCollapsed: () => void;
}) => {
  const { defaultConfigId } = useDefaultPromptConfig();
  const [storedConfigIdToLoad, setStoredConfigIdToLoad] = useState<
    string | undefined
  >(defaultConfigId);
  const prompt = usePlaygroundStore(useDeep((state) => state.prompts[0]));
  const setPrompt = usePlaygroundStore((state) => state.setPrompt);

  const { manifest } = prompt;

  return (
    <div className="flex w-full shrink-0 items-center gap-2 pl-4">
      <div>Prompt</div>
      <div className="my-auto h-px flex-grow bg-[#EAECF0] dark:bg-[#1F242F]" />
      <div className="ml-auto flex items-center gap-1 overflow-x-hidden no-scrollbar">
        <PromptSettingsDisplay
          manifest={manifest}
          variant="evaluator"
          setManifest={(value) =>
            setPrompt(0, (prev) => ({
              ...prev,
              manifest: {
                ...prev.manifest,
                kwargs: {
                  ...prev.manifest.kwargs,
                  last: value.kwargs.last,
                },
              },
              hubPrompt: prev.hubPrompt
                ? {
                    ...prev.hubPrompt,
                    edited: true,
                  }
                : undefined,
            }))
          }
          storedConfigIdToLoad={storedConfigIdToLoad}
          setStoredConfigIdToLoad={setStoredConfigIdToLoad}
        />
      </div>
      <ChevronToggle
        isAllCollapsed={isAllCollapsed}
        setIsAllCollapsed={setIsAllCollapsed}
      />
    </div>
  );
};
